// extracted by mini-css-extract-plugin
module.exports = {"top_logo":"top_logo-1jb0mpNH"};